// extracted by mini-css-extract-plugin
module.exports = {"container":"VideoPagination_container__1PGzs","text":"VideoPagination_text__1vsLf","icon":"VideoPagination_icon__MIJ0o","disabled":"VideoPagination_disabled__1v8aq"};